import React from 'react';
import { useTranslation } from 'react-i18next';
import { CartesianGrid, Line, LineChart, YAxis } from 'recharts';

function SpeedChart({ result }) {
  const { t, i18n } = useTranslation();
  let data = [{
    "name": "Page A",
    "top": 100,
    "middle": 66.7,
    "bottom": 0,
    "uv": 0,
  },];

  if (result?.calclSpedCordn) {
    data = [];
    const temp = result.calclSpedCordn.split(":");
    if (temp.length > 0) {
      temp.forEach((item) => {
        data.push({
          "top": 100,
          "middle": 66.7,
          "bottom": 0,
          "uv": item.split(",")[1],
        })
      })
    }
  }

  const yLineTitle = (e) => {
    if (e === 100) return t("LC_02_09_result.msg025");
    else if (e === 66) return t("LC_02_09_result.msg026");
    else if (e === 0) return t("LC_02_09_result.msg027");
  }

  return (
    <React.Fragment>
      <LineChart
        width={276}
        height={172}
        data={data}
        margin={{ top: 25, bottom: 12 }}
      >
        {
          data.length === 1 && (
            <CartesianGrid
              strokeDasharray="6 6"
              vertical={false}
              stroke="#466482"
            />
          )
        }
        <YAxis
          width={ i18n.language === 'en' ? 55 : 30 }
          tick={{ fontSize: 12,  fill: '#788ca0' }}
          ticks={[100.1, 100, 66, 0]}
          tickFormatter={yLineTitle}
        />
        <Line
          hide={data.length === 1}
          storke
          type="monotone"
          dataKey="top"
          stroke="#466482"
          dot={false}
          activeDot={false}
          strokeWidth={1}
          strokeDasharray="6 6"
        />
        <Line
          hide={data.length === 1}
          type="monotone"
          dataKey="middle"
          stroke="#466482"
          dot={false}
          activeDot={false}
          strokeWidth={2}
        />
        <Line
          hide={data.length === 1}
          type="monotone"
          dataKey="bottom"
          stroke="#466482"
          strokeDasharray="6 6"
          dot={false}
          activeDot={false}
          strokeWidth={1}
        />
        <Line
          type="monotone"
          dataKey="uv"
          stroke="#ff6e5f"
          strokeWidth={4}
          dot={false}
        />
      </LineChart>
    </React.Fragment>
  );
}

export default SpeedChart;